import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { DietasCadastrarComponent } from './../dietas/cadastrar/cadastrar.component';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class CadastrarDietasDeactivateGuard implements CanDeactivate<DietasCadastrarComponent> {
        
    constructor() {}
        
    canDeactivate(
        component: DietasCadastrarComponent,
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean>|Promise<boolean>|boolean {    
        
        // if(component.nomePacienteSelecionado != null){
        //     console.log(component.nomePacienteSelecionado);
        //     if(component.nomePacienteSelecionado == "Paciente não Encontrado"){
        //         console.log("oe3");    
        //         return true;
        //     }else{
        //         console.log("oei");
        //         return false;
        //     }            
            
        // }else{
        //     console.log("oei2");
        //     component.nomePacienteSelecionado = "Paciente não Encontrado";
        //     return true;
        // }
        return true;
        
    }
}



// WEBPACK FOOTER //
// ./src/app/guards/c-dietas-deactivate.guard.ts